"use client";

import { motion, Variants } from "framer-motion";
import { ReactNode } from "react";

interface ScrollAnimationProps {
  children: ReactNode;
  animation?: "fade-in" | "slide-up" | "scale-up" | "slide-left";
  delay?: number;
  className?: string;
  viewportOnce?: boolean;
}

export default function ScrollAnimation({
  children,
  animation = "fade-in",
  delay = 0,
  className = "",
  viewportOnce = true,
}: ScrollAnimationProps) {
  
  // Varianten für verschiedene Animationstypen
  const variants: Record<string, Variants> = {
    "fade-in": {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.8, ease: "easeOut" } },
    },
    "slide-up": {
      hidden: { opacity: 0, y: 60 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    },
    "scale-up": {
      hidden: { opacity: 0, scale: 0.9 },
      visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } },
    },
    "slide-left": {
      hidden: { opacity: 0, x: -60 },
      visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
    },
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: viewportOnce, margin: "-100px" }}
      variants={variants[animation]}
      transition={{ delay: delay / 1000 }} // Framer Motion nutzt Sekunden
      className={className}
    >
      {children}
    </motion.div>
  );
}